/**
 * Deze klasse handelt het maken indelen van de groepjes gereed, er is al een nieuwe ronde gemaakt, dus daar de instructie tekst in zetten, eventueel ll laten slepen door de leerkracht
 *
 * @history
 * 3 augustus 2023
 * puntjes op de i voor de lay-out
 *
 * 25 juli 2023
 * Er zijn nu maximaal zes plaatsen per groep
 *
 * 14 juni 2023
 * kopie GroupBuilder ivm aangepaste implementatie
 *
 */

import React from "react";
import {GroupForm} from "../forms/GroupForm";




import {DraggablePupil} from "../helpers/DraggablePupil";
import {DroppablePupils} from "../helpers/DroppablePupils";
import {DroppablePupilsAll} from "../helpers/DroppablePupilsAll";
import {Dragger} from "./Dragger";

export class GroupInit extends React.Component
{
    constructor(props)
    {
        super(props);

        this.state =
            {
                groups_loaded: false,
                groups: [],
                pupils_loaded: false,
                pupils: [],

                show_edit_group: false,

                curr_group_index: -1,

            };



        this.refreshGroups = this.refreshGroups.bind(this);
        this.handleGroupForm = this.handleGroupForm.bind(this);

        this.editGroupClicked = this.editGroupClicked.bind(this);


        this.handleDragEnd = this.handleDragEnd.bind(this);
        this.handleDragStart = this.handleDragStart.bind(this);
        this.resetGroupsClicked = this.resetGroupsClicked.bind(this);


    }


    editGroupClicked(p_index)
    {
        this.setState(
            {
                show_edit_group: true,
                curr_group_index: p_index

            }
        )
    }


    async handleGroupForm(p_reload, p_group)
    {
        if (p_reload)
        {
            await this.refreshGroups();
            this.setState({

                show_edit_group: false
            });

        } else
        {
            this.setState({

                show_edit_group: false
            });
        }

    }

    async refreshGroups()
    {
        const formData = new FormData();


        formData.append("access_id1", window.app.logboek.access_id1);
        formData.append("access_id2", window.app.logboek.access_id2);
        formData.append("round", window.app.logboek.getSessionField('current_round'));
        const requestOptions = {
            method: 'POST',
            body: formData
        };

        await fetch("/get_groups", requestOptions)
            .then(response => response.json())
            .then(groups_json =>
            {

                if (groups_json.status == "ok")
                {
                    console.log(groups_json.data);
                    this.setState({
                        groups: groups_json.data,
                        groups_loaded: true
                    });


                } else
                {
                    console.log("?");
                }
            });
    }

    componentDidMount()
    {
        this.refreshGroups();
        this.loadPupils();
    }


    async loadPupils()
    {
        const formData = new FormData();
        formData.append("session_id", window.app.logboek.id);

        const requestOptions = {
            method: 'POST',
            body: formData
        };

        await fetch("/get_active_pupils", requestOptions)
            .then(response => response.json())
            .then(json =>
            {
                if (json.status == "ok")
                {

                    this.setState({
                        pupils: json.data,
                        pupils_loaded: true
                    });


                } else
                {
                    console.log("?");
                }
            });
    }

    handleDragEnd(event)
    {
        /* regel nu de aanpassing in de datastructuur
          over.id == group_index
          active.id == pupil_index
         */
        if (event.over != null)
        {
            let new_pupils = this.state.pupils;

            const group_index = event.over.data.current.group_index;
            const pupil_index = event.active.data.current.pupil_index;

            if (group_index == "-1")
            {
                new_pupils[pupil_index].group_id = 0;
            } else
            {
                if (event.over.data.current.occupied)
                {
                    return false;
                }
                new_pupils[pupil_index].group_id = this.state.groups[group_index].id;
            }


            // en dan nu ook nog opslaan
            const formData = new FormData();
            formData.append("session_id", window.app.logboek.id);
            formData.append("pupil_id", new_pupils[pupil_index].id);
            formData.append("group_id", new_pupils[pupil_index].group_id);

            const requestOptions = {
                method: 'POST',
                body: formData
            };

/*            console.log(document.getElementById(event.active.id).style.zIndex);
            document.getElementById(event.active.id).style.zIndex = '1000';
            console.log(document.getElementById(event.active.id).style.zIndex);
*/
            fetch("/store_active_pupil", requestOptions)
                .then(response => response.json())
                .then(json =>
                {
                    this.setState({
                        pupils: new_pupils
                    })
                });
        }

    }

    handleDragStart(event)
    {
     /*   console.log(event);
        console.log(document.getElementById(event.active.id).style.zIndex);
        document.getElementById(event.active.id).style.zIndex = '10000';
        console.log(document.getElementById(event.active.id).style.zIndex);*/
    }



    resetGroupsClicked()
    {
        const formData = new FormData();
        formData.append("session_id", window.app.logboek.id);

        const requestOptions = {
            method: 'POST',
            body: formData
        };

        fetch("/reset_active_pupil_groups", requestOptions)
            .then(response => response.json())
            .then(json =>
            {
                this.loadPupils();
            });
    }



    render()
    {


        this.group_free = {};
        if (this.state.groups_loaded && this.state.pupils_loaded)
        {
            // dit kan beter, maar we willen per group_index weten hoeveel pupils al aanwezig zijn

            for (let g = 0; g < this.state.groups.length; g++)
            {
                this.group_free["g" + this.state.groups[g].id] = [1, 2, 3, 4, 5, 6];
            }
            console.log(this.group_free);

            for (let p = 0; p < this.state.pupils.length; p++)
            {
                if (this.state.pupils[p].group_id != 0)
                {
                    this.group_free["g" + this.state.pupils[p].group_id].pop();
                }
            }

           // console.log(this.group_free);
        }

     //   console.log("render groupinit");

        return (

            <div className={"tool__content__groupbuilder__wrapper"}>


                {!this.state.groups_loaded && !this.state.show_edit_group &&
                    (
                        <p style={{"text-align": "center", "margin-top": "45vh"}}>Even geduld AUB, alle gegevens worden
                            ingeladen</p>
                    )}


                {this.state.groups_loaded && !this.state.show_edit_group && (this.state.groups.length == 0 ||this.state.pupils.length == 0) &&
                    (
                        <p style={{"color":"#F00"}}>Je moet eerst nog een aantal hoeken en kinderen selecteren op de twee voorgaande schermen voordat je verder kan gaan.</p>
                    )}

                {this.state.groups_loaded && !this.state.show_edit_group && this.state.groups.length > 0 && this.state.pupils.length > 0 &&
                    (
                <Dragger onDragEnd={this.handleDragEnd} onDragStart={this.handleDragStart} >


                                <div className={"tool__content__groupbuilder__content__group__wrapper"}>
                                    {this.state.groups.map((group, group_index) =>

                                        (

                                            <div className="tool__content__groupbuilder__content__group">


                                                 <div className="tool__content__groupbuilder__content__group_image" style={group.location.has_image == "Y" ? {
                                                     "background-image": "url('" + group.location.image_url + "')",
                                                     "background-size": "cover",
                                                     "background-repeat": "no-repeat"
                                                 } : {}}>

                                                </div>
                                                <div
                                                    className={"tool__content__groupbuilder__content__group_head"}> {group.location.title}


                                                    {this.props.mode != 'divide' && (
                                                        <a href="javascript:void(0)"
                                                           onClick={() => this.editGroupClicked(group_index)}><img
                                                            src={"/digibord/assets/svgs/ui/pencil_white.svg"}
                                                            className={"ui_icon_small"} style={{float: "right"}}/></a>
                                                    )}
                                                </div>
                                                {this.state.pupils_loaded && (
                                                    <div className="tool__content__groupbuilder__content__group__pupils">
                                                        {this.state.pupils.map((pupil, pupil_index) =>
                                                            (
                                                                    <>
                                                                    {group.id == pupil.group_id &&
                                                                            <DroppablePupils id={"g" + pupil_index} kind="group" group_index={group_index} occupied={true}>
                                                                        <DraggablePupil id={"p" + pupil_index} pupil_index={pupil_index}
                                                                                        >
                                                                            <div className={"draggable_pupil"}
                                                                                 style={pupil.has_image == "Y" ? {
                                                                                     "background-image": "url('" + pupil.image_url + "')",
                                                                                     "background-size": "contain"
                                                                                 } : {}}>
                                                                                <div
                                                                                    className={"draggable_pupil_name"}>{pupil.name}</div>
                                                                            </div>
                                                                        </DraggablePupil>
                                                                            </DroppablePupils>

                                                                    }
                                                                    </>

                                                            ))
                                                        }
                                                        <>
                                                            {this.group_free["g"+group.id].length > 0 &&
                                                                (
                                                                    <>
                                                                        {this.group_free["g"+group.id].map(( dummy_index) =>
                                                                            (
                                                                                <DroppablePupils id={"g" + group_index +999 +dummy_index} kind="group" group_index={group_index} occupied={false}>
                                                                                </DroppablePupils>
                                                                            ))
                                                                        }
                                                                    </>

                                                                )}
                                                        </>
                                                    </div>
                                                )
                                                }



                                            </div>

                                        ))
                                    }

                                </div>



                                <div style={{"clear": "both"}}></div>


                                {this.state.pupils_loaded && (
                                    <div className={"tool__content__groupbuilder__content__nogroup__pupils"}>
                                        <DroppablePupilsAll id={"g-1"} kind="free" group_index={-1}>
                                            {this.state.pupils.map((pupil, pupil_index) =>
                                                (
                                                    <>
                                                        {pupil.group_id == 0 &&

                                                            <DraggablePupil id={"p" + pupil_index} pupil={pupil} pupil_index={pupil_index}>
                                                                <div className={"draggable_pupil"}
                                                                     style={pupil.has_image == "Y" ? {
                                                                         "background-image": "url('" + pupil.image_url + "')",
                                                                         "background-size": "contain"
                                                                     } : {}}>
                                                                    <div
                                                                        className={"draggable_pupil_name"}>{pupil.name}</div>
                                                                </div>
                                                            </DraggablePupil>
                                                        }
                                                    </>
                                                ))
                                            }
                                        </DroppablePupilsAll>
                                    </div>
                                )}



                </Dragger>
                    )}
                {this.state.show_edit_group &&
                    (
                        <GroupForm finished_callback={this.handleGroupForm}
                                   instruction={this.state.groups[this.state.curr_group_index].instruction}
                                   group_id={this.state.groups[this.state.curr_group_index].id}
                                   location={this.state.groups[this.state.curr_group_index].location.title}
                                   icons={this.state.groups[this.state.curr_group_index].icons}
                                   has_image={this.state.groups[this.state.curr_group_index].has_image === "Y"}
                                   has_audio={this.state.groups[this.state.curr_group_index].has_audio === "Y"}
                                   image_url={(this.state.groups[this.state.curr_group_index].has_image === "Y") ? this.state.groups[this.state.curr_group_index].image_url : ""}
                                   audio_url={(this.state.groups[this.state.curr_group_index].has_audio === "Y") ? this.state.groups[this.state.curr_group_index].audio_url : ""}
                                   action={"edit"}/>
                    )}


            </div>


        );
    }

}
